module.exports = __webpack_public_path__ + "static/img/guide_03.537b773.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/guide_03.gif
// module id = qW2Z
// module chunks = 1